import React, { useRef } from "react";
import { useAppDispatch, useAppSelector } from "../store/configureStore";
import { NOT_YET } from "../reducers/notixProfileSlice";
import { setAlert } from "../reducers/alertSlice";
import Translate from "../Components/Translate";
import { COLOR, Warning } from "@propellerads/icon";
import { ALERT_TYPES } from "@propellerads/alert";

const useLegalInfo = (): void => {
  const {
    legal_info: {
      legal_info_missing: legalInfoMissing,
      legal_info_left_days: legalInfoLeftDays,
    },
    status,
  } = useAppSelector((store) => store.notixProfile);

  const dispatch = useAppDispatch();

  const isAlertMounted = useRef<boolean>(false);

  if (legalInfoMissing && status !== NOT_YET && !isAlertMounted.current) {
    const legalInfoTime = <Translate tag="legal_info_time" />;
    const legalInfoFinish = <Translate tag="legal_info_finish" />;
    const daysLeft = <Translate tag="legal_info_days_left" />;

    const message = legalInfoLeftDays ? (
      <>
        {legalInfoTime} {legalInfoLeftDays} {daysLeft}.
      </>
    ) : (
      legalInfoFinish
    );

    const color = legalInfoLeftDays ? COLOR.WARNING : COLOR.ERROR;
    const type = legalInfoLeftDays ? ALERT_TYPES.WARNING : ALERT_TYPES.DANGER;

    dispatch(
      setAlert({
        message: message,
        type: type,
        icon: <Warning color={color} />,
      })
    );

    isAlertMounted.current = true;
  }
};

export default useLegalInfo;
